/**
 * @description 将字节单位的大小转换为人类可读的字符串，单位为 KB、MB、GB 等。
 * @param {number} bytes 以字节为单位的大小
 * @return {string} 包含单位的字符串
 */
export function bytesToHumanReadableSize(bytes) {

  if (bytes === 0) {
    return '0';
  } else if (bytes===void 0){
    return void 0
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let i = 0;
  while (bytes > 1024 && i < units.length - 1) {
    bytes /= 1024;
    i++;
  }

  return `${bytes.toFixed(1)} ${units[i]}`;
}
// 设置相对时间 ///////////////////////////////////////////
function formatRelativeTime(pastTime) {
  const currentTime = new Date(); // 获取当前时间
  const past = new Date(pastTime); // 将传入的过去时间转换为 Date 对象

  const elapsedMilliseconds = currentTime - past; // 计算时间间隔的毫秒数

  // 定义时间单位与毫秒数的对应关系
  const timeIntervals = [
    { unit: "year", interval: 1000 * 60 * 60 * 24 * 365 },
    { unit: "month", interval: 1000 * 60 * 60 * 24 * 30 },
    { unit: "day", interval: 1000 * 60 * 60 * 24 },
    { unit: "hour", interval: 1000 * 60 * 60 },
    { unit: "minute", interval: 1000 * 60 },
    { unit: "second", interval: 1000 },
  ];


  // 遍历时间单位，找到最适合的单位
  for (let i = 0; i < timeIntervals.length; i++) {
    const { unit, interval } = timeIntervals[i];
    const elapsedUnits = Math.floor(elapsedMilliseconds / interval);
    if (elapsedUnits >= 1) {
      return `${elapsedUnits} ${unit}${elapsedUnits > 1 ? "s" : ""} ago`;
    }
  }

  return "Just now"; // 如果时间间隔非常短，返回"Just now"
}
// 设置相对时间 ///////////////////////////////////////////

function compareIds(a, b) {
  /** 
   * 判断两个数组的id是否有相同的，有返回真
   * @param {Array} a 
   * @param {Array} b
   * @returns {Blob} 
  */
  for (let i = 0; i < a.length; i++) {
    for (let j = 0; j < b.length; j++) {
      if (a[i].native_id === b[j].native_id) {
        // console.log(i);
        return true; // IDs match, return false
      }
    }
  }
  return false; // No matching IDs found, return true
}
//
function get_LS_Item(ItemName = "access_token") {
  /**
   * get Local Store Item 创建一个函数 返回、获取实时的 token 值 | 返回 false
   */
  const value = localStorage.getItem(ItemName);
  //
  if (value) {
    // 如果token存在，再继续执行
    if (ItemName === "access_token") {
      return value;
    } else if (ItemName === "refresh_token") {
      return value;
    } else if (ItemName === "account_name") {
      return value;
    } else {
      // console.log(4011, "token 名称无效");
    }
  } else {
    // console.log(4002, ItemName, "不存在, 表示未登录状态");
    return false;
  }
}
export {
  formatRelativeTime, // 传入时间，返回相对时间
  // hasIntersection,    // 
  // isSuperset,
  // hasIntersectionObj,
  compareIds,
  get_LS_Item, // 初次使用在 src/axiosInstance/qwe22291.js
};
